import React from 'react';
import { Button, Color, Icon, Text } from '@bb/elements-web';
import styled from 'styled-components';

interface PaymentBannerProps {
  /** Message to display in the banner about the outstanding payment */
  message: string;
  /** Whether or not to show the Pay Now button or not */
  showPayNowButton: boolean;
  /** Function to navigate to the Pay Now modal */
  goToPayNowModal?: () => void;
}

const PaymentBanner: React.FC<PaymentBannerProps> = ({
  message,
  showPayNowButton,
  goToPayNowModal,
}) => (
  <Background>
    <BannerContainer>
      <Icon icon={'closeFilled'} color="danger" size={16} />
      <BannerText>{message}</BannerText>
      {showPayNowButton && (
        <Button
          size="small"
          shape="default"
          type="primary"
          onClick={goToPayNowModal}
          dataCy={'pay-now-button-banner'}
          styleOverride={customBannerButtonStyle}
        >
          Pay Now
        </Button>
      )}
    </BannerContainer>
  </Background>
);

export default PaymentBanner;

const Background = styled.div`
  display: flex;
  background-color: #fff2f0; // TODO: convert to constant
  border: 1px solid #ffccc7; // TODO: convert to constant
  border-radius: 8px;
`;

const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 12px 14px;
  align-items: center;
`;

const BannerText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: ${Color.PRIMARY_TEXT};
  align-self: center;
  margin-left: 12px;
  margin-right: 12px;
  flex: 1;
`;

/**
 * Custom style because we need the banner to be pretty small height wise.
 * This makes it so there's only horizontal padding and the button shrinks
 * to fit the content horizontally as well.
 */
const customBannerButtonStyle = {
  padding: '0px 16px',
  minWidth: 0,
};
